import * as Sentry from '@sentry/react'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'local',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import { logger } from './utils/logger.ts'
import { initializeRTLPlugin } from './utils/mapbox.ts'

// Initialize Mapbox RTL plugin for Arabic text support
initializeRTLPlugin();

// Global error handlers
window.onerror = (message, source, lineno, colno, error) => {
  logger.error('Global error', error, {
    message: String(message),
    source,
    line: lineno,
    column: colno,
  });
};

window.onunhandledrejection = (event) => {
  logger.error('Unhandled promise rejection', event.reason, {
    type: 'unhandledrejection',
  });
};

// Log app startup
logger.info('Fleet Management App starting', {
  environment: import.meta.env.MODE,
  apiUrl: import.meta.env.VITE_API_BASE_URL,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
